import styles from './SidebarEditor.module.css'
import React, { useMemo, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { FormBuilderContext } from '../../store/store.FormBuilder'

const SidebarEditor = observer(() => {
  const storeFormBuilder = useContext(FormBuilderContext)
  return <div className={styles.navbar}></div>
})

export default SidebarEditor
